import React from 'react';

import bbva_png from '../media/logos/bbva.png';
import threeb_png from '../media/logos/3b.png';
import actinver_png from '../media/logos/actinver.png';
import airpack_png from '../media/logos/airpack.png';
import aki_png from '../media/logos/aki.png';
import alsuper_png from '../media/logos/alsuper.png';
import ati_png from '../media/logos/ati.png';
import aurrera_png from '../media/logos/aurrera.png';
import bancomer_png from '../media/logos/bancomer_opt.jpg';
import bancopel_png from '../media/logos/bancopel.svg';
import barri_png from '../media/logos/barri.png';
import cecom_png from '../media/logos/cecom.png';
import chedraui_png from '../media/logos/chedraui.png';
import circulog_png from '../media/logos/circulog.png';
import circuloK_png from '../media/logos/circuloK.png';
import delsol_png from '../media/logos/delsol.png';
import dinex_png from '../media/logos/dinex.png';
import donneto_png from '../media/logos/donneto.png';
import elaustriano_png from '../media/logos/elaustriano.png';
import epago_png from '../media/logos/epago.png';
import extra_png from '../media/logos/extra.png';
import farm_png from '../media/logos/farm.png';
import farmahorro_png from '../media/logos/farmahorro.png';
import farmapronto_png from '../media/logos/farmapronto.png';
import farmbenavides_png from '../media/logos/farmbenavides.png';
import farmsanpablo_png from '../media/logos/farmsanpablo.png';
import fundaciondonde_png from '../media/logos/fundaciondonde.png';
import ganmas_png from '../media/logos/ganmas.png';
import gestopago_png from '../media/logos/gestopago.png';
import hibye_png from '../media/logos/hibye.png';
import kapitalbank_png from '../media/logos/kapitalbank.png';
import intercambioexpress_png from '../media/logos/intercambioexpress.png';
import hsbc_png from '../media/logos/hsbc.png';
import kiosko_png from '../media/logos/kiosko.png';
import lacomer_png from '../media/logos/lacomer.png';
import laoriginal_png from '../media/logos/laoriginal.png';
import ldi_png from '../media/logos/ldi.png';
import ley_png from '../media/logos/ley.png';
import liquis_png from '../media/logos/liquis.png';
import maxi_png from '../media/logos/maxi.png';
import megacomercial_png from '../media/logos/megacomercial.png';
import soriana_mercado_png from '../media/logos/soriana_mercado.png';
import merza_png from '../media/logos/merza.png';
import mic_png from '../media/logos/mic.png';
import mobilecard_png from '../media/logos/mobilecard.png';
import multiredglobal_jpg from '../media/logos/multiredglobal.jpg';
import netpay_png from '../media/logos/netpay.png';
import oxxo_png from '../media/logos/oxxo.png';
import puntorecarga_png from '../media/logos/puntorecarga.png';
import redefectiva_png from '../media/logos/redefectiva.png';
import tconecta_png from '../media/logos/tconecta.png';
import sams_png from '../media/logos/sams-1.png';
import seveneleven_png from '../media/logos/seveneleven.png';
import six_png from '../media/logos/six.png';
import sorianasuper_jpg from '../media/logos/sorianasuper.png';
import sorianaexpress_jpg from '../media/logos/sorianaexpress.png';
import suburbia_png from '../media/logos/suburbia.png';
import superkompras_png from '../media/logos/superkompras.png';
import finabien_png from '../media/logos/finabien.png';
import waldos_png from '../media/logos/waldos.png';
import walmart_png from '../media/logos/walmart.png';
import willis_png from '../media/logos/willis.png';
import wolworth_png from '../media/logos/wolworth.png';
import yastas_png from '../media/logos/yastas.png';
import rappi_png from '../media/logos/rappi.png';
import walmartxpress_png from '../media/logos/walmartxpress.png';
import neto_png from '../media/logos/NETO.png';
import mtc_png from '../media/logos/MTC.png';
import ganamas_png from '../media/logos/GANAMAS.png';
import yomp_png from '../media/logos/Yomp.png';
import farmatodo_png from '../media/logos/farmatodo.png';
import albo_png from '../media/logos/albo.png';
import grupomovilmexico_png from '../media/logos/grupomovilmexico.png';
import yaganastes_png from '../media/logos/yaganastes.png';
import bcentral_png from '../media/logos/bcentral.png';
import pagaaqui_png from '../media/logos/pagaaqui.png';
import bx_png from '../media/logos/bx.png';
import cash_png from '../media/logos/cash.png';
import sys_tienda_png from '../media/logos/sys_tienda.png';
import mexicana_png from '../media/logos/mexicana.png';
import mercaday_png from '../media/logos/mercaday.png';
import mix_png from '../media/logos/mix.png';
import fresko_png from '../media/logos/fresko.png';
import sumesa_png from '../media/logos/sumesa.png';
import via_png from '../media/logos/via.png';
import super_city_png from '../media/logos/super_city.png';
import cashi_png from '../media/logos/cashi-1.png';
import citymarket_png from '../media/logos/citymarket.png';

import redefectiva_gif from '../media/logos/redefectiva.gif';
import farmacon_jpg from '../media/logos/Logo FarmaCon.jpg';
import yza_png from '../media/logos/yza.png';
import logofarmacialamoderna_png from '../media/logos/logofarmacialamoderna.png';
import mispagos_png from '../media/logos/mispagos.png';
import fasti_png from '../media/logos/fasti.png';
import unodostres_png from '../media/logos/unodostres.png';
import cuenca_png from '../media/logos/cuenca.png';
import vepormas_png from '../media/logos/vepormas.png';
import superiberia_png from '../media/logos/superiberia.png';
import superred_png from '../media/logos/superred.png';
import asea_png from '../media/logos/asea.png';
import cashapoyo_png from '../media/logos/cashapoyo.png';
import laferre_png from '../media/logos/laferre.png';
import mercadopago_png from '../media/logos/mercadopago.png';

import rico_supertienda_png from '../media/logos/rico_supertienda.png';
import lamasbarata_png from '../media/logos/lamasbarata.png';
import logrand_png from '../media/logos/logrand.png';



import googleplay from '../media/googleplay.png';
import appstore from '../media/appstore.png';

class PlacesOfPayment extends React.Component
{
    render()
    {
        return (

  



            <div id='places-of-payment' className='container'>
                <div className='mt-5 text-center title-above-borders borders-dark'>
                    <h2 className='text-uppercase font-bold text-primary bg-light'>FORMAS Y LUGARES DE PAGO </h2>

                    <p><b>CON TARJETA DE CRÉDITO O DÉBITO: </b></p>
                    
                        <p>Llámanos al <a href='tel:5556101010'>55 56 10 10 10</a> de lunes a domingo las 24 horas. </p>
                        <p>¡O paga desde <a href="https://micuentaon.oninternet.com.mx/index.php" target="_blank">aquí</a>! Solo ingresa a Mi cuenta ON </p>
                    

                    <p><b>EN EFECTIVO:</b></p>
                    <p>En alguno de los lugares autorizados. Descarga la app ON Internet, en donde encontrarás toda la información que te pedirán: </p>
                    
                        <p>Referencia de pago </p>
                        <p>Monto total </p>
                        <p>Fecha límite de pago </p>
                    

                    <p>Descárgala desde aquí: </p>
                      <center>
                                        <ul>
                                            <li className="google">
                                                <a href="https://play.google.com/store/apps/details?id=mx.com.dish.oninternet" target="_blank">
                                                    <img alt="Google Play" src={googleplay}/>
                                                </a>
                                            </li>
                                            <li className="ios">
                                                <a href="https://apps.apple.com/us/app/on-internet/id1484378436?l=es&ls=1" target="_blank">
                                                    <img alt="App Store" src={appstore}/>
                                                </a>    
                                            </li>
                                        </ul>
                      </center>

                   
                    <p>No olvides mencionar que deseas pagar un <b>servicio de Dish. </b></p>
                </div>
                
                   
                   
              

                <div className='my-4 text-center border border-primary'>
                   
                <div className='bg-primary text-light p-2 text-uppercase'>Reflejan tu pago de inmediato</div>
                
                   
                   {/*<img src={dish_png} alt='dish_png' height='50' />*/}

            <div class="wrapper">      
                <div class="one">
                    <img src={hsbc_png} alt='hsbc_png' />
                    <img src={bbva_png} alt='bbva_png' />
                    <img src={finabien_png} alt='finabien_png' />
                    <img src={ley_png} alt='ley_png'/>
                    <img src={aurrera_png} alt='aurrera_png' className='kiosk_png' class="one"/>
                    <img src={walmart_png} alt='walmart_png' className='kiosk_png' />
                    <img src={walmartxpress_png} alt='walmartexpress_png' className='kiosk_png' />
                    <img src={sams_png} alt='sams_png' className='kiosk_png' />
                </div>
                
                <div class="two">
                    <img src={suburbia_png} alt='suburbia_png' className='kiosk_png' />
                    <img src={tconecta_png} alt='tconecta_png' className='kiosk_png'/>
                    <img src={extra_png} alt='extra_png' className='kiosk_png' />
                    <img src={farmbenavides_png} alt='farmbenavides_png' className='kiosk_png' />
                    <img src={kapitalbank_png} alt='kapitalbank_png' className='kiosk_png' />
                    <img src={netpay_png} alt='netpay_png' className='kiosk_png' />
                    <img src={redefectiva_png} alt='redefectiva' className='kiosk_png' />
                    <img src={fundaciondonde_png} alt='fundaciondonde_png' className='kiosk_png' />
                </div>

                <div class="three">
                    
                    <img src={threeb_png} alt='3b_png' className='kiosk_png' />
                    <img src={kiosko_png} alt='kiosko_png' className='kiosk_png' />
                    <img src={wolworth_png} alt='wolworth_png' className='kiosk_png' />
                    <img src={neto_png} alt='neto_png' className='kiosk_png' />
                    <img src={alsuper_png} alt='alsuper_png' className='kiosk_png' />
                    <img src={yastas_png} alt='yastas_png' className='kiosk_png' />
                    <img src={waldos_png} alt='waldos_png' className='kiosk_png' />
                    <img src={puntorecarga_png} alt='puntorecarga_png' className='kiosk_png' />
                </div>   

                <div class="four">
                    <img src={fasti_png} alt='fasti' className='kiosk_png' />
                    <img src={airpack_png} alt='airpack_png' className='kiosk_png' />
                    <img src={six_png} alt='six_png' className='kiosk_png' />
                    <img src={ldi_png} alt='ldi_png' className='kiosk_png' />
                    <img src={farmsanpablo_png} alt='farmsanpablo_png' className='kiosk_png' />
                    <img src={farmapronto_png} alt='farmapronto_png' className='kiosk_png' />
                    <img src={mtc_png} alt='mtc_png' className='kiosk_png' />
                    <img src={oxxo_png} alt='oxxo_png' className='kiosk_png' />
                </div>  

                <div class="five">
                    <img src={elaustriano_png} alt='elaustriano_png' className='kiosk_png' />
                    <img src={seveneleven_png} alt='seveneleven_png' className='kiosk_png' />
                    <img src={ganamas_png} alt='ganamas_png' className='kiosk_png' />
                    <img src={yomp_png} alt='yomp' className='kiosk_png' />
                    <img src={barri_png} alt='barri_png' className='kiosk_png' />
                    <img src={dinex_png} alt='dinex_png' className='kiosk_png' />
                    <img src={farmatodo_png} alt='farmatodo_png' className='kiosk_png' />
                    <img src={intercambioexpress_png} alt='intercambioexpress_png' className='kiosk_png' />
                </div>   
                    
                <div class="six">
                    <img src={maxi_png} alt='maxi_png' className='kiosk_png' />
                    <img src={circuloK_png} alt='circuloK_png' className='kiosk_png' />
                    <img src={cecom_png} alt='cecom_png' className='kiosk_png' />
                    <img src={superkompras_png} alt='superkompras_png' className='kiosk_png' /> 
                    <img src={rappi_png} alt='rappi_png' className='kiosk_png' />
                    <img src={gestopago_png} alt='gestopago_png' className='kiosk_png' />
                    <img src={farmahorro_png} alt='farmahorro_png' className='kiosk_png' />
                    <img src={superiberia_png} alt='superiberia' className='kiosk_png' />
                </div>    
                    
                <div class="seven">
                    <img src={albo_png} alt='albo' className='kiosk_png' />
                    <img src={hibye_png} alt='hibye_png' className='kiosk_png' />
                    <img src={aki_png} alt='aki_png' className='kiosk_png' />
                    <img src={merza_png} alt='merza_png' className='kiosk_png' />
                    <img src={grupomovilmexico_png} alt='grupomovilmexico_png' className='kiosk_png' />
                    <img src={willis_png} alt='willis_png' className='kiosk_png' />
                    <img src={delsol_png} alt='delsol_png' className='kiosk_png' />
                    <img src={yaganastes_png} alt='yaganastes_png' className='kiosk_png' />
                </div>   
                    
                <div class="eight">
                    
                    <img src={bcentral_png} alt='bcentral_png' className='kiosk_png' />
                    <img src={actinver_png} alt='actinver_png' className='kiosk_png' />
                    <img src={yza_png} alt='yza' className='kiosk_png' />
                    <img src={pagaaqui_png} alt='pagaaqui' className='kiosk_png' />
                    <img src={logofarmacialamoderna_png} alt='logofarmacialamoderna' className='kiosk_png' />
                    <img src={cuenca_png} alt='cuenca' className='kiosk_png' />
                    <img src={unodostres_png} alt='unodostres' className='kiosk_png' />
                    <img src={bx_png} alt='bx' className='kiosk_png' />
                </div>    
                    
                <div class="nine">
                    <img src={bancopel_png} alt='bancopel_png' className='kiosk_png' />
                    <img src={superred_png} alt='superred' className='kiosk_png' />
                    <img src={asea_png} alt='asea' className='kiosk_png' />
                    <img src={cashapoyo_png} alt='cashapoyo' className='kiosk_png' />
                    <img src={laferre_png} alt='laferre' className='kiosk_png' />
                    <img src={mercadopago_png} alt='mercadopago' className='kiosk_png' />
                    <img src={rico_supertienda_png} alt='supertiendasrico' className='kiosk_png' />
                    <img src={lamasbarata_png} alt='lamasbarata_png' className='kiosk_png' />
                </div>   
                    
                <div class="ten">
                    <img src={cash_png} alt='cash_png' className='kiosk_png' />
                    <img src={sys_tienda_png} alt='sys_tienda_png' className='kiosk_png' />
                    <img src={lacomer_png} alt='lacomer_png' />
                    <img src={mexicana_png} alt='mexicana_png' className='kiosk_png'/>
                    <img src={mercaday_png} alt='mercaday_png' className='kiosk_png'/>
                    <img src={mix_png} alt='mix_png' className='kiosk_png'/>
                    <img src={fresko_png} alt='fresko_png' className='kiosk_png'/>
                    <img src={sumesa_png} alt='sumesa_png' className='kiosk_png'/>
                </div>   
                    
                <div class="eleven">
                    <img src={citymarket_png} alt='citymarket_png' className='kiosk_png'/>
                    <img src={via_png} alt='via_png' className='kiosk_png'/>
                    <img src={logrand_png} alt='logrand_png' className='kiosk_png' />
                    <img src={sorianasuper_jpg} alt='sorianasuper_jpg' />
                    <img src={sorianaexpress_jpg} alt='sorianasuper_png' />
                    <img src={soriana_mercado_png} alt='sorianamercado' />
                    <img src={super_city_png} alt='super_city_png' className='kiosk_png'/>
                    <img src={mispagos_png} alt='mispagos' className='kiosk_png' />
                </div>    
                    
                <div class="twelve">
                    <img src={cashi_png} alt='cashi' className='kiosk_png' />
                </div> 

            </div>  
                    
                
                
                    

                    
                   
                   
        



                    <div className='text-primary p-2 text-uppercase'>Estos establecimientos te cobra comisión por el pago de tu servicio</div>
                </div>
                {/*<div className='my-4 text-center'>
                    <div className='bg-primary text-light p-2 text-uppercase'>Reflejan tu pago al día siguiente</div>
                    
                  
                </div>*/}
                <div className='my-4 text-center'>
                    <div className='bg-primary text-light p-2 text-uppercase'>REFLEJA TU PAGO AL D&Iacute;A SIGUIENTE Y COBRA COMISI&Oacute;N</div>
                    <img src={chedraui_png} alt='chedraui_png' />
                </div>
            </div>
        );
    }
}

export default PlacesOfPayment;



// WEBPACK FOOTER //
// ./src/components/PlacesOfPayment.js